<template>
    <div class="page" ref="scroller">
        <van-list
            class="list"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <div class="item" :id="item.id" v-for="item in list" :key="item.id">
                <div class="titleBox">
                    <div class="title" @click="goComment(item)">
                        {{ item.title }}
                    </div>
                    <span class="mark" v-if="item.pass">{{
                        item.pass && "已加精"
                    }}</span>
                </div>
                <div class="desc">
                    {{ item.content }}
                </div>
                <div
                    class="reply"
                    v-for="child in item.childrenList"
                    :key="child.id"
                >
                    <span class="relyer">{{ child.name }}回复：</span>
                    <div class="reply-content" v-html="child.content"></div>
                </div>
                <div class="footer">
                    <span class="time">{{ item.createTime }}</span>
                    <div class="right">
                        <img
                            class="thumbLogo"
                            src="~@/assets/thumb-logo.png"
                            alt=""
                        />
                        <span>{{ item.likeNum }}</span>
                        <img
                            class="commentLogo"
                            src="~@/assets/comment-logo.png"
                            alt=""
                        />
                        <span>{{ item.childrenList.length }}</span>
                    </div>
                </div>
            </div>
        </van-list>
        <no-content :msg="'暂无评论'" v-if="showNoContent"></no-content>
    </div>
</template>

<script>
    import userCenterService from "../../service/user-center.service";
    import noContent from "../../components/no-content/no-content";
    import scrollerMixin from "../../scroller.mixin";
    export default {
        name: "my-comment",
        components: {
            "no-content": noContent,
        },
        mixins: [scrollerMixin],
        data() {
            return {
                list: [],
                page: 0,
                loading: true,
                finished: false,
                showNoContent: false,
            };
        },
        mounted() {
            if (this.loading) {
                this.onLoad();
            }
        },
        methods: {
            onLoad() {
                userCenterService
                    .userMessage({ page: this.page })
                    .then((res) => {
                        this.page++;
                        this.loading = false;
                        this.list.push(...res.data.list);
                        if (this.list.length <= 0) {
                            this.showNoContent = true;
                            this.loading = false;
                            this.finished = true;
                        }
                        if (this.list.length >= res.data.count) {
                            this.finished = true;
                        }
                        setTimeout(() => {
                            let id = this.$route.query.id;
                            let el = document.getElementById(id);
                            el.scrollIntoView();
                        }, 0);
                    });
            },
            goComment(obj) {
                switch (obj.type) {
                    case "EVENING_PAPER":
                        location.href =
                            "http://daoda1997.daoda1997.cn/Products/EveningPaper/article";
                        break;
                    case "EMOTION":
                        location.href = `/emotion3/comment#${obj.id}`;
                        break;
                    case "STUDY_EPISODE":
                        this.$router.push({
                            path: `/video-course/${obj.clssifyforId}`,
                            query: { courseId: obj.studyId, commentId: obj.id },
                        });
                        break;
                }
            },
        },
    };
</script>

<style lang="scss" scoped src="./my-comment.scss"></style>
